import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import msal from 'lib/msal';
import { clearLocalStorage } from 'helpers/localstorage';

var Logout = /*#__PURE__*/function (_Component) {
  _inherits(Logout, _Component);

  var _super = _createSuper(Logout);

  function Logout(props) {
    var _this;

    _classCallCheck(this, Logout);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "allStorage", function () {
      var archive = [],
          keys = Object.keys(localStorage),
          i = 0,
          key;

      for (; key = keys[i]; i++) {
        archive.push(key + '=' + localStorage.getItem(key));
      }

      return archive;
    });

    var foundAdalinStorage = _this.allStorage().findIndex(function (item) {
      return item.indexOf('adal') > -1;
    });

    if (foundAdalinStorage > -1) {
      clearLocalStorage();
      msal.logoutRedirect();
    } else {
      msal.logoutRedirect();
    }

    return _this;
  }

  _createClass(Logout, [{
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return Logout;
}(Component);

export { Logout as default };